function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M497.1,147.6l-21.5-21.5c-9.6-9.6-22.4-14.9-35.9-14.9h0c-13.6,0-26.4,5.3-36,14.9l-58.4,58.3v-36 c0-12.5-5.1-24.8-14-33.7l-72.9-72.9c-8.9-8.9-21.1-14-33.6-14H47.5C21.3,27.9,0,49.3,0,75.4v361.2c0,26.2,21.3,47.5,47.5,47.5 h250.2c26.2,0,47.5-21.3,47.5-47.5v-67c4.8-3.6,9.7-7.3,14.1-11.8l137.8-138.3c9.6-9.6,14.9-22.4,14.9-36 C512,170,506.7,157.2,497.1,147.6z M234.1,139V73.3l65.7,65.7H234.1z M305.7,436.7c0,4.4-3.6,8-8,8H47.5c-4.4,0-8-3.6-8-8V75.4 c0-4.4,3.7-8.1,8-8.1h147v84.5c0,14.7,12,26.7,26.7,26.7h84.4v45.1l-40.4,40.2c-24.3,24.2-39.4,56.8-42.4,90.9 c-6.1-9.1-15.8-15.6-27.4-18.1c-10.3-2.2-20.8-0.9-29.5,3.5l-9.7-29c-3.7-10.9-13.8-18.3-25.3-18.3c-11.5,0-21.7,7.3-25.3,18.3 l-15.8,47.5c-0.5,1.6-2,2.6-3.6,2.6H75.3c-10.9,0-19.8,8.9-19.8,19.8s8.9,19.8,19.8,19.8h10.8c18.7,0,35.2-11.9,41.1-29.7l3.7-11 l9,27.2c2.6,7.7,9.3,12.9,17.4,13.4c8.1,0.5,15.4-3.6,19-10.9l6.7-13.3c1-2,2.9-2.1,3.4-2.1h0c0.9,0,2.6,0.3,3.6,2.4 c7.3,14.5,21.8,23.7,38,23.9H256c16.5,0,33.6-3.1,49.7-9V436.7z M331.3,330L331.3,330c-18.4,18.5-43.3,29.6-69.3,31.1 c1.5-26,12.7-50.9,31.2-69.3l100.6-100l37.6,37.6L331.3,330z M469.2,191.6l-14.3,14.3l-37.6-37.6l14.3-14.3c4.4-4.4,11.6-4.4,16,0 l21.5,21.5C473.6,180,473.6,187.2,469.2,191.6z"
});

var SvgIconConfirmOrder = function SvgIconConfirmOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconConfirmOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_confirm_order.61a9b2ca.svg";
export { ForwardRef as ReactComponent };